import isDark from '../../../../common/verifiers/is-dark';
import increaseColorPointByRatio from '../../../../common/utils/increase-color-point-by-ratio';
import reduceColorPointByRatio from '../../../../common/utils/reduce-color-point-by-ratio';

const primary = (params) => {
  const { backgroundColor, errorColorPalette: targetColorPalette } = params;

  const fallback = {
    rule: 'input.borderColor.error.primary',
    params,
  };
  if (!isDark(backgroundColor)) {
    return increaseColorPointByRatio(
      {
        targetColor: targetColorPalette[50],
        targetColorPalette,
        backgroundColor,
        condition: (ratio) => ratio >= 3,
        fallback,
      },
      '50'
    );
  }

  return reduceColorPointByRatio(
    {
      targetColor: targetColorPalette[900],
      targetColorPalette,
      backgroundColor,
      condition: (ratio) => ratio >= 3.5,
      fallback,
    },
    '900'
  );
};

export default primary;
